import React from 'react';
import styled from 'styled-components';
export default function FormLabelForm({ children, className, width = 98, }) {
    return (React.createElement(StyledFormLabelForm, { className: className, width: width }, children));
}
const StyledFormLabelForm = styled.div `
  width: ${(props) => props.width}px;
`;
